export enum ServiceStatus {
  UP = 'UP',
  IMPAIRED = 'IMPAIRED',
  ON_BACKUP = 'ON BACKUP',
  DOWN = 'DOWN',
}

export const SERVICE_STATUS_BY_SEVERITY = Object.freeze([
  ServiceStatus.DOWN,
  ServiceStatus.ON_BACKUP,
  ServiceStatus.IMPAIRED,
  ServiceStatus.UP,
]);

export const SERVICE_STATUS_COLORS = Object.freeze({
  [ServiceStatus.UP]: '#3dcc64',
  [ServiceStatus.IMPAIRED]: '#ffbb2c',
  [ServiceStatus.ON_BACKUP]: '#ffbb2c',
  [ServiceStatus.DOWN]: '#ef4732',
});

export const DEFAULT_SERVICE_STATUS_COLOR =
  SERVICE_STATUS_COLORS[ServiceStatus.UP];
